import React, { Component } from "react";
import Amplify from "aws-amplify";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Modal, InputGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactPasswordStrength from 'react-password-strength';
// API Urls
import APIUrls from "../../constants/ApiUrls";
import { APIManager } from "../../utils/api";
import LoaderButton from "../../components/LoaderButton";
import CamelLogo from "../../assets/images/main-logo-white.png";
import "./PasswordReset.scss";

const modalStyle = () => {
  // we use some psuedo random coords so nested modals
  // don't sit right on top of each other.
  let top = window.innerHeight / 2 - 214;
  let left = window.innerWidth / 2 - 230;

  return {
    position: 'fixed',
    width: 460,
    zIndex: 1040,
    top: top + 'px',
    bottom: top + 'px',
    left: left + 'px',
  };
};

const authSettings = {
  mandatorySignIn: true,
  region: "us-west-2",
  userPoolId: "us-west-2_X9qh8CBP6",
  identityPoolId: "us-west-2:0b763a53-720d-440d-a083-983740ec27d1",
  userPoolWebClientId: "g9g7hl6e7mlhauhg4nff6fs53",
};

class PasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newPassword: null,
      // confirmPassword: null,
      isLoading: false,
      error: null,
      user: null
    };
  }

  async componentDidMount() {
    let { search } = this.props.location;

    if (!search || search === '') {
      this.props.history.push('/login');
    }
    search = search.split('CODE')[2];

    const params = search.slice(1, search.length).split('&');
    const email = params[3].split('=')[1];
    try {
      await this.setUpCognito(email);
    } catch (e) {
      this.setState({ error: e.message });
      toast.error('Failed to get cognito user: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  setUpCognito = async (email) => {
    // lookup tenant for given email
    let data = null;
    try {
      data = await APIManager.Instance.call("GET", APIUrls.getTenant(email));
    } catch (e) {
      this.setState({ error: e.message });

      toast.error('Failed to get tenant user: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    const { tenant } = data; // TODO clean up return values
    authSettings.userPoolId = tenant.userPoolId;
    authSettings.identityPoolId = tenant.identityPoolId;
    authSettings.userPoolWebClientId = tenant.appClientId;

    Amplify.configure({
      Auth: authSettings
    });

    return data;
  }

  onChangePassword = (e) => {
    this.setState({ newPassword: e.target.value, error: null });
  }

  onSubmitNewPassword = async () => {
    const { newPassword } = this.state;
    const { search } = this.props.location;
    
    if (newPassword && newPassword.length < 12) {
      this.setState({ error: 'Please choose a stronger password' });
      return;
    } 
    this.setState({ isLoading: true });
  
    const params = search.slice(1, search.length).split('&');
    const code = params[0].split('=')[1].replace(/CODE/g, '');
    const username = params[1].split('=')[1];

    try {
      await Amplify.Auth.forgotPasswordSubmit(username, code, newPassword);
      this.setState({ error: null, isLoading: false });

      this.props.history.push('/login');
    } catch (e) {
      this.setState({ error: e.message, isLoading: false });

      toast.error('Failed to reset password: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  // onChangeConfirmPassword = (e) => {
  //   this.setState({ confirmPassword: e.target.value, error: null });
  // }

  render() {
    const { isLoading } = this.state;

    return (
      <div className="password-reset-container">
        <Modal
          onHide={this.close}
          style={modalStyle()}
          aria-labelledby="modal-label"
          show={true}
          className="forgot"
        >
          <div className="modal-header">
            <img src={CamelLogo} alt="camel logo" />
          </div>
          <div className="content">
            <h2>Reset password</h2>
            <p className="sub-title mb-5">Choose a new, strong password</p>
            <InputGroup className="mb-1">
              <ReactPasswordStrength
                className="customClass"
                minLength={12}
                minScore={4}
                scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
                changeCallback={(e) => this.onChangePassword({ target: { value: e.password } })}
                inputProps={{ name: "password_input", autoComplete: "new-password", className: "form-control" }}
              />
            </InputGroup>
            {/* <InputGroup className="mb-4">
              <FormControl
                placeholder="Confirm password"
                aria-label="Confirm Password"
                type="password"
                aria-describedby="basic-addon1"
                onChange={this.onChangeConfirmPassword}
              />
            </InputGroup> */}
            <LoaderButton
              block
              type="submit"
              isLoading={isLoading}
              text="CHANGE PASSWORD"
              loadingText="CHANGING PASSWORD..."
              className="btn-danger"
              onClick={this.onSubmitNewPassword}
            />
            {this.state.error && <p className="mt-2" style={{ color: 'red' }}>{this.state.error}</p>}
            <div className="d-flex flex-column mt-4">
              <Link className="mr-5" to="/forgot-password">Re-send reset password request</Link>
              <Link to="/login">Login page</Link>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
